import Button from '@app/common/components/Button';
import Panel from '@app/common/components/Panel';
import { getEocSubscriptionStatusOrNull, getIsTrialSubscription } from '@app/selectors/agency';
import React from 'react';
import { useSelector } from 'react-redux';

import styles from './AddOns.module.scss';
import { useEocAccessApi } from '@app/containers/dashboard/documents/exchangeOfContracts/eoc-form/hooks/useEocAccessApi';
import { AddonStatus, AddonStatus as AddOnStatus } from '@app/config';

const AddOns: React.FC = () => {
    const eocSubscriptionStatus = useSelector(getEocSubscriptionStatusOrNull);
    const isTrialSubscription = useSelector(getIsTrialSubscription);

    const { enableEocAccessMutation, disableEocAccessMutation } = useEocAccessApi();

    const handleToggleEocAccess = async () => {
        if (eocSubscriptionStatus === AddOnStatus.ACTIVE) {
            disableEocAccessMutation.mutate();
        } else if (eocSubscriptionStatus === AddOnStatus.INACTIVE) {
            enableEocAccessMutation.mutate();
        }
    };

    // Only return if eocSubscriptionStatus is defined
    return eocSubscriptionStatus === null ? null : (
        <Panel title="Add-ons">
            <div className={styles.container}>
                <p className={styles.description}>
                    Enable add-ons you want to make available for your agency — you'll only be charged for what you use.
                </p>
                <div className={styles.addOns}>
                    <div className={styles.info}>
                        <h4 className={styles.title}>Exchange of Contracts</h4>
                        <p className={styles.price}>
                            {isTrialSubscription ? 'included as part of your Free Trial' : 'Free until August 2025*'}
                        </p>
                    </div>
                    <Button
                        type="button"
                        primary
                        className={styles.toggleButton}
                        onClick={handleToggleEocAccess}
                        loading={enableEocAccessMutation.isLoading || disableEocAccessMutation.isLoading}
                        disabled={isTrialSubscription}
                    >
                        {eocSubscriptionStatus === AddonStatus.ACTIVE ? 'Disable' : 'Enable'}
                    </Button>
                </div>
                {!isTrialSubscription && (
                    <div className={styles.disclaimer}>*Standard price: $20 AUD (plus GST) per contract sent</div>
                )}
            </div>
        </Panel>
    );
};

export default AddOns;
